/*
 * Quiz "¿Qué hongo es para ti?" — FunFungi
 * Un solo archivo: lógica pura (puntuar, historia) + interfaz tipo conversación + ilustraciones.
 * La lógica se prueba en Node (module.exports); la interfaz se monta con FFQuiz.montar().
 * Reglas fijas:
 *  - Las respuestas de seguridad (p7) nunca se guardan ni se envían.
 *  - Nada de lógica de promos: el quiz solo agrega productos a precio de lista.
 */
(function (global) {
  'use strict';

  /* ---------- Lógica ---------- */

  var HONGOS = ['melena', 'reishi', 'cordyceps', 'cola_de_pavo'];
  var RAMA_HONGO = { foco: 'melena', descanso: 'reishi', energia: 'cordyceps', defensas: 'cola_de_pavo' };

  var PESOS_SENAL = {
    f_parrafo: { melena: 2 }, f_pieza: { melena: 2 }, f_celular: { melena: 1 },
    f_niebla: { melena: 2, cordyceps: 1 }, f_memoria: { melena: 2 },
    d_cabeza: { reishi: 2 }, d_despierto: { reishi: 2 }, d_cansado: { reishi: 2, cordyceps: 1 },
    d_paciencia: { reishi: 2, melena: 1 }, d_pantalla: { reishi: 1 },
    e_cafe: { cordyceps: 2 }, e_bajon: { cordyceps: 2 }, e_entreno: { cordyceps: 3 }, e_cosas: { cordyceps: 2 },
    i_resfrio: { cola_de_pavo: 2 }, i_recupero: { cola_de_pavo: 2 }, i_guata: { cola_de_pavo: 2 },
    i_largo: { cola_de_pavo: 1, melena: 1 }
  };
  var PESOS_CUIDARSE = { c_rendir: { melena: 3 }, c_familia: { cordyceps: 3 }, c_cabeza: { melena: 3 }, c_salud: { cola_de_pavo: 3 } };

  // Dúos que existen en la tienda. Clave: hongos ordenados alfabéticamente.
  var DUOS = { 'cordyceps+melena': 1, 'melena+reishi': 1, 'cola_de_pavo+reishi': 1, 'cola_de_pavo+cordyceps': 1 };

  var STOP = ['embarazo', 'menor14', 'oncologico'];
  var CONSULTA = ['medicamentos', 'anticoag', 'diabetes', 'inmuno', 'hepatica', 'cirugia'];

  // Hábitos: se eligen los 2 primeros que calzan, partiendo por los de la rama principal.
  var HABITOS = [
    { id: 'h_resfrio', rama: 'cola_de_pavo', si: ['i_resfrio', 'i_recupero'] },
    { id: 'h_plantas', rama: 'cola_de_pavo', si: ['i_guata', 'x_defensas'] },
    { id: 'h_cafe', rama: 'reishi', si: ['d_cabeza', 'd_despierto', 'e_cafe', 't_cafe'] },
    { id: 'h_pantalla', rama: 'reishi', si: ['d_pantalla', 'f_celular', 'd_cabeza'] },
    { id: 'h_siesta', rama: 'cordyceps', si: ['e_bajon', 'f_niebla'] },
    { id: 'h_ejercicio', rama: 'cordyceps', si: ['e_cosas', 'e_entreno', 'x_energia'], salvo: 't_rutina' },
    { id: 'h_dormir7', rama: 'melena', si: ['f_parrafo', 'f_pieza', 'f_memoria', 'd_cansado', 'x_foco', 'x_descanso'] }
  ];

  // Duración del estudio citado, para el diagrama "qué esperar". Sin dato = sin marca.
  var SEMANAS_ESTUDIO = { melena: 8, reishi: 8, cordyceps: 3 };

  function lista(a) { return Array.isArray(a) ? a : []; }
  function tiene(a, id) { return lista(a).indexOf(id) !== -1; }
  function claveDuo(a, b) { return [a, b].sort().join('+'); }

  function pasos(r) {
    // Sin preguntas de salud (decisión de Mau, 09-10): siempre se recomienda. Las precauciones quedan en el aviso del pie y en las fichas (el acordeón se sacó el 12-10).
    var p = ['p1', 'p2', 'p3', 'p5'];
    if (r && r.p1 === 'cuidarse') p = p.filter(function (x) { return x !== 'p3'; });
    return p;
  }

  function disponible(productos, clave) {
    var p = productos && productos[clave];
    return !!(p && p.disponible !== false && p.variante);
  }

  /**
   * r = { p1, p2[], p3[], p4, p5, p6[], p7[] }
   * productos (opcional) = { melena, reishi, cordyceps, cola_de_pavo, 'duo:a+b', pack4, funcoffee } con { variante, disponible }
   */
  function puntuar(r, productos) {
    r = r || {};
    var s = { melena: 0, reishi: 0, cordyceps: 0, cola_de_pavo: 0 };
    var cruzado = {};
    var sumar = function (pesos) { if (pesos) Object.keys(pesos).forEach(function (h) { s[h] += pesos[h]; }); };

    var rama = r.p1;
    if (RAMA_HONGO[rama]) s[RAMA_HONGO[rama]] += 10;
    lista(r.p2).forEach(function (id) { sumar(PESOS_SENAL[id]); });
    if (rama !== 'cuidarse') {
      lista(r.p3).forEach(function (id) {
        var h = RAMA_HONGO[id.replace(/^x_/, '')];
        if (h) { s[h] += 4; cruzado[h] = true; }
      });
    }
    if (rama === 'cuidarse') sumar(PESOS_CUIDARSE[r.p5]);

    var orden = HONGOS.slice().sort(function (a, b) { return s[b] - s[a] || HONGOS.indexOf(a) - HONGOS.indexOf(b); });
    var p = orden[0], q = orden[1];
    var senales = lista(r.p2).filter(function (x) { return x !== 'c_nada'; });
    var sinNecesidad = rama === 'cuidarse' && senales.length === 0;
    var altos = HONGOS.filter(function (h) { return s[h] >= 4; });
    var yaCliente = tiene(r.p6, 't_ff');

    var segundo = null;
    if (!sinNecesidad && s[q] >= 4 && (cruzado[q] || rama === 'cuidarse')) segundo = q;

    var oferta;
    if (yaCliente && altos.length >= 3) {
      oferta = { tipo: 'pack4', hongos: [p], clave: 'pack4' };
    } else if (segundo) {
      var k = claveDuo(p, segundo);
      oferta = DUOS[k] ? { tipo: 'duo', hongos: [p, segundo], clave: 'duo:' + k } : { tipo: 'dos', hongos: [p, segundo] };
    } else {
      oferta = { tipo: 'single', hongos: [p], clave: p };
    }

    // Disponibilidad: el dúo agotado pasa a dos frascos; si no hay stock, solo "ver ficha".
    if (productos) {
      if (oferta.tipo === 'duo' && !disponible(productos, oferta.clave)) oferta = { tipo: 'dos', hongos: oferta.hongos };
      if (oferta.tipo === 'pack4' && !disponible(productos, 'pack4')) oferta = { tipo: 'single', hongos: [p], clave: p };
      var compra = oferta.tipo === 'dos' ? oferta.hongos : [oferta.clave];
      oferta.disponible = compra.every(function (c) { return disponible(productos, c); });
    }

    // Alternativas (máximo 2)
    var alt = [];
    if (altos.length >= 3 && oferta.tipo !== 'pack4') alt.push({ tipo: 'pack4', clave: 'pack4' });
    if (oferta.tipo === 'single' && !sinNecesidad && s[q] >= 2) {
      var kq = claveDuo(p, q);
      alt.push(DUOS[kq] ? { tipo: 'duo', hongos: [p, q], clave: 'duo:' + kq } : { tipo: 'single', hongos: [q], clave: q });
    }
    var tomaCafe = tiene(r.p2, 'e_cafe') || tiene(r.p6, 't_cafe');
    if (tomaCafe && (oferta.hongos.indexOf('melena') !== -1 || oferta.hongos.indexOf('cordyceps') !== -1)) {
      alt.push({ tipo: 'funcoffee', clave: 'funcoffee' });
    }
    if (productos) alt = alt.filter(function (a) { return disponible(productos, a.clave); });
    alt = alt.slice(0, 2);

    // Seguridad: siempre gana
    var f = (r.p7 === 'si' ? lista(r.p7b) : lista(r.p7)).filter(function (x) { return x !== 'ninguna'; });
    var modo = f.some(function (x) { return STOP.indexOf(x) !== -1; }) ? 'stop'
      : f.some(function (x) { return CONSULTA.indexOf(x) !== -1; }) ? 'consulta' : 'normal';

    // Hábitos
    var marcadas = [].concat(lista(r.p2), lista(r.p3), lista(r.p6));
    var habitos = HABITOS.filter(function (h) {
      return h.si.some(function (x) { return marcadas.indexOf(x) !== -1; }) && !(h.salvo && marcadas.indexOf(h.salvo) !== -1);
    }).sort(function (a, b) {
      return (oferta.hongos.indexOf(b.rama) !== -1) - (oferta.hongos.indexOf(a.rama) !== -1);
    }).map(function (h) { return h.id; }).slice(0, 2);
    if (!habitos.length && RAMA_HONGO[rama]) habitos = ['h_dormir7'];

    // Notas honestas según lo que ya probó
    var notas = [];
    if (tiene(r.p6, 't_cafe')) notas.push('t_cafe');
    if (tiene(r.p6, 't_dormir') && oferta.hongos.indexOf('reishi') !== -1) notas.push('t_dormir');
    ['t_suplementos', 't_hongos', 't_rutina'].forEach(function (n) { if (tiene(r.p6, n)) notas.push(n); });

    return {
      puntajes: s, principal: p, oferta: oferta, alternativas: alt, modo: modo,
      avisos: f, sinNecesidad: sinNecesidad, habitos: habitos, notas: notas,
      desdeAnos: r.p4 === 'anos', cierre: r.p5 || null
    };
  }

  /* ---------- Resumen: lo que nos contaste, en una o dos frases ---------- */

  function buscar(T, paso, id) {
    var q = T.preguntas[paso];
    if (!q) return null;
    var ops = [].concat(q.opciones || [], q.opciones_cuidarse || []);
    for (var i = 0; i < ops.length; i++) if (ops[i].id === id) return ops[i];
    return null;
  }
  function unir(items) {
    if (items.length <= 1) return items.join('');
    return items.slice(0, -1).join(', ') + ' y ' + items[items.length - 1];
  }
  function mayus(t) { return t ? t.charAt(0).toUpperCase() + t.slice(1) : t; }
  function plantilla(t, datos) { return t.replace(/\{(\w+)\}/g, function (_, k) { return datos[k] != null ? datos[k] : ''; }); }

  /**
   * Devuelve segmentos [{t, eco}] para resaltar las palabras de la persona.
   * Ej.: "Llegas sin pila al final del día, sin café no funcionas y te cuesta concentrarte. Y te preocupa no tener energía para los tuyos."
   * Máximo 2 señales para que se lea de un vistazo.
   */
  function resumen(r, T) {
    var eco = function (paso, id) { var o = buscar(T, paso, id); return o && o.eco ? o.eco : ''; };
    var partes = [eco('p1', r.p1)];
    lista(r.p2).forEach(function (id) { partes.push(eco('p2', id)); });
    if (r.p1 !== 'cuidarse') lista(r.p3).forEach(function (id) { partes.push(eco('p3', id)); });
    partes = partes.filter(Boolean).slice(0, 3);
    var seg = [];
    partes.forEach(function (x, i) {
      if (i > 0) seg.push({ t: i === partes.length - 1 ? ' y ' : ', ' });
      seg.push({ t: i === 0 ? mayus(x) : x, eco: true });
    });
    if (seg.length) seg.push({ t: '. ' });
    var e5 = eco('p5', r.p5);
    if (e5) {
      var base = r.p1 === 'cuidarse' ? T.resultado.resumen_importa : T.resultado.resumen_preocupa;
      var corte = base.split('{eco}');
      seg.push({ t: corte[0] }, { t: e5, eco: true }, { t: corte[1] || '' });
    }
    return seg;
  }

  /* ---------- Ilustraciones (SVG generado, sin imágenes externas) ---------- */

  var SOMBRA = 'rgba(46,42,57,.10)';
  var MADERA = '#E9D9C6', MADERA_2 = '#D8C4AC';
  function f1(n) { return n.toFixed(1); }

  function svg(contenido, clase) {
    return '<svg class="' + (clase || '') + '" viewBox="0 0 120 120" aria-hidden="true" focusable="false">' + contenido + '</svg>';
  }
  function suelo() { return '<ellipse cx="60" cy="108" rx="34" ry="5" fill="' + SOMBRA + '"/>'; }

  // Melena de León: pompón sin sombrero ni pie, pegado al costado de un tronco y cubierto
  // de espinas en gota que cuelgan (cortas arriba, largas abajo). Las filas van de abajo
  // hacia arriba para que cada una tape la raíz de la de abajo, como pelo.
  function ilusMelena() {
    var gota = function (x, y, w, L, c) {
      return '<path d="M' + f1(x - w) + ' ' + f1(y) + ' A' + f1(w) + ' ' + f1(w) + ' 0 0 1 ' + f1(x + w) + ' ' + f1(y) +
        ' C' + f1(x + w) + ' ' + f1(y + L * .4) + ' ' + f1(x + .6) + ' ' + f1(y + L) + ' ' + f1(x) + ' ' + f1(y + L) +
        ' C' + f1(x - .6) + ' ' + f1(y + L) + ' ' + f1(x - w) + ' ' + f1(y + L * .4) + ' ' + f1(x - w) + ' ' + f1(y) + ' Z" fill="' + c + '"/>';
    };
    var TONOS = ['#5BA8E0', '#6DB3E6', '#4A97D2', '#5BA8E0', '#6DB3E6'];
    var s = suelo();
    s += '<rect x="84" y="10" width="26" height="100" rx="7" fill="' + MADERA + '"/>';
    s += '<path d="M92 18 V40 M101 30 V60 M93 74 V100" stroke="' + MADERA_2 + '" stroke-width="2.2" stroke-linecap="round"/>';
    var cx = 51, cy = 54, rx = 35, ry = 30;
    s += '<ellipse cx="' + cx + '" cy="' + (cy + 4) + '" rx="' + (rx - 4) + '" ry="' + (ry - 3) + '" fill="#2070AB"/>';
    for (var r = 7; r >= 0; r--) {
      var y = cy - ry + 4 + r * 6.6;
      var t = (y - cy) / ry, hw = Math.max(6, rx * Math.sqrt(Math.max(0, 1 - t * t)) - 1);
      var L = 9 + r * 2.3;
      var n = Math.max(2, Math.round(hw * 2 / 6.6)), dx = hw * 2 / n;
      for (var i = 0; i <= n; i++) {
        var x = cx - hw + i * dx + (r % 2 ? dx / 2 : 0);
        if (x > cx + hw + 1) continue;
        var l = L + ((i * 7 + r * 3) % 5) * 1.4 - 2.8 - (i === 0 || i === n ? 3 : 0);
        s += gota(x, y, dx * .56, l, r === 0 ? '#7CBBE8' : TONOS[(i * 3 + r) % 5]);
        if (r >= 5 && i % 3 === 1) s += '<path d="M' + f1(x - 1.1) + ' ' + f1(y + 2) + ' Q' + f1(x - 1.3) + ' ' + f1(y + l * .6) + ' ' + f1(x) + ' ' + f1(y + l - 2) + '" stroke="#E3F0FA" stroke-width="1.2" stroke-linecap="round" fill="none" opacity=".8"/>';
      }
    }
    s += '<path d="M30 36 C35 30 41 27 48 26" stroke="#E3F0FA" stroke-width="3" stroke-linecap="round" fill="none" opacity=".8"/>';
    return s;
  }

  function ilusReishi() {
    var cap = 'M14 60 C12 36 36 18 62 18 C90 18 110 36 106 56 C104 68 90 70 78 64 C66 58 54 62 42 68 C28 74 15 72 14 60 Z';
    var capa = function (k, color) {
      return '<path d="' + cap + '" fill="' + color + '" transform="translate(60 62) scale(' + k + ') translate(-60 -62)"/>';
    };
    var s = suelo();
    s += '<path d="M62 64 C64 78 58 92 52 104" stroke="#7A2A1C" stroke-width="11" stroke-linecap="round" fill="none"/>';
    s += '<path d="M60 70 C61 82 57 92 53 100" stroke="#A33A26" stroke-width="3" stroke-linecap="round" fill="none" opacity=".6"/>';
    s += capa(1.04, '#F0B54E') + capa(0.94, '#C0432E') + capa(0.74, '#9E3422') + capa(0.52, '#7F2819') + capa(0.3, '#62200F');
    s += '<ellipse cx="44" cy="34" rx="18" ry="5" fill="#fff" opacity=".28" transform="rotate(-18 44 34)"/>';
    return s;
  }

  function ilusCordyceps() {
    var s = suelo();
    s += '<path d="M34 104 C40 96 80 96 86 104 Z" fill="' + MADERA + '"/>';
    var tallos = [
      { x0: 46, x1: 30, y1: 30 }, { x0: 54, x1: 50, y1: 18 }, { x0: 62, x1: 70, y1: 26 },
      { x0: 68, x1: 90, y1: 38 }, { x0: 58, x1: 58, y1: 46 }
    ];
    tallos.forEach(function (t, i) {
      var cx = (t.x0 + t.x1) / 2 + (i % 2 ? 6 : -6);
      s += '<path d="M' + t.x0 + ' 100 Q' + cx + ' ' + (t.y1 + 40) + ' ' + t.x1 + ' ' + (t.y1 + 18) + '" stroke="#F59A45" stroke-width="5.5" stroke-linecap="round" fill="none"/>';
      s += '<line x1="' + t.x1 + '" y1="' + (t.y1 + 18) + '" x2="' + t.x1 + '" y2="' + t.y1 + '" stroke="#F27D1A" stroke-width="11" stroke-linecap="round"/>';
      for (var d = 0; d < 3; d++) s += '<circle cx="' + (t.x1 + (d % 2 ? 2 : -2)) + '" cy="' + (t.y1 + 3 + d * 6) + '" r="1.2" fill="#A9530A" opacity=".55"/>';
    });
    return s;
  }

  // Cola de Pavo: repisas en abanico, delgadas, de borde ondulado y bandas concéntricas,
  // creciendo en roseta sobre un tronco caído.
  function abanico(ox, oy, r, a0, a1, rot) {
    var forma = function (k) {
      var d = 'M' + f1(ox) + ' ' + f1(oy), pasos = 28;
      for (var i = 0; i <= pasos; i++) {
        var a = (a0 + (a1 - a0) * i / pasos) * Math.PI / 180;
        var rr = r * k * (1 + .06 * Math.sin(i * 1.15) * k);
        d += ' L' + f1(ox + Math.cos(a) * rr) + ' ' + f1(oy - Math.sin(a) * rr);
      }
      return d + ' Z';
    };
    var bandas = [[1, '#FFFFFF'], [.93, '#20755C'], [.8, '#8FCFB8'], [.7, '#2A9B7A'], [.56, '#DDF0EA'], [.46, '#1B5E4A'], [.3, '#2A9B7A']];
    return '<g transform="rotate(' + rot + ' ' + ox + ' ' + oy + ')" stroke-linejoin="round">' +
      bandas.map(function (b) { return '<path d="' + forma(b[0]) + '" fill="' + b[1] + '"/>'; }).join('') + '</g>';
  }
  function ilusColaDePavo() {
    var s = suelo();
    s += '<rect x="16" y="86" width="90" height="18" rx="9" fill="' + MADERA + '"/>';
    s += '<ellipse cx="98" cy="95" rx="6" ry="9" fill="' + MADERA_2 + '"/><ellipse cx="98" cy="95" rx="3" ry="5" fill="none" stroke="#C4AD92" stroke-width="1.4"/>';
    s += abanico(40, 90, 30, 14, 166, -14);
    s += abanico(78, 90, 32, 14, 166, 12);
    s += abanico(58, 94, 27, 16, 164, 0);
    return s;
  }

  var ILUS = { melena: ilusMelena, reishi: ilusReishi, cordyceps: ilusCordyceps, cola_de_pavo: ilusColaDePavo };
  function ilustracion(h, clase) { return ILUS[h] ? svg(ILUS[h](), clase) : ''; }

  var AVATAR = '<svg viewBox="0 0 32 32" aria-hidden="true" focusable="false"><circle cx="16" cy="16" r="16" fill="#2B2622"/>' +
    '<path d="M7 16.5C7 11 11 8 16 8s9 3 9 8.5c0 1-.8 1.5-1.8 1.5H8.8C7.8 18 7 17.5 7 16.5Z" fill="#fff"/>' +
    '<path d="M13.5 18h5l-.6 5.2a1.9 1.9 0 0 1-3.8 0Z" fill="#fff" opacity=".85"/></svg>';

  var ICONOS = {
    atras: '<path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>',
    check: '<path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>',
    flecha: '<path d="M5 12h13M13 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>',
    gota: '<path d="M12 3.5c3.5 4.4 6 7.7 6 10.6A6 6 0 0 1 6 14.1c0-2.9 2.5-6.2 6-10.6z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>',
    vaso: '<path d="M6 4h12l-1.6 15.2a2 2 0 0 1-2 1.8H9.6a2 2 0 0 1-2-1.8L6 4z M7 9h10" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>',
    calendario: '<rect x="4" y="5.5" width="16" height="14.5" rx="2.5" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M4 10h16M8.5 3.5v4M15.5 3.5v4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>',
    reloj: '<circle cx="12" cy="12" r="8.2" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M12 7.5V12l3 2" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>',
    externo: '<path d="M14 5h5v5M19 5l-8 8M17 14v4a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 5 18v-9A1.5 1.5 0 0 1 6.5 7.5H10" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>',
    escudo: '<path d="M12 3.5l7 2.8v5.4c0 4.3-2.9 7.6-7 8.8-4.1-1.2-7-4.5-7-8.8V6.3l7-2.8z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M12 8.5v4.2M12 15.6v.1" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>',
    estrella: '<path d="M12 3.8l2.5 5.1 5.6.8-4.1 4 1 5.6L12 16.6l-5 2.7 1-5.6-4.1-4 5.6-.8z" fill="currentColor"/>',
    candado: '<rect x="5.5" y="10.5" width="13" height="9.5" rx="2" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M8.5 10.5V8a3.5 3.5 0 0 1 7 0v2.5" fill="none" stroke="currentColor" stroke-width="1.8"/>',
    rehacer: '<path d="M4.5 12a7.5 7.5 0 1 0 2.4-5.5M4.5 4.5v4h4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>',
    compartir: '<path d="M12 15V4M8 8l4-4 4 4M5 13v5.5A1.5 1.5 0 0 0 6.5 20h11a1.5 1.5 0 0 0 1.5-1.5V13" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>',
    libro: '<path d="M4 5.5A1.5 1.5 0 0 1 5.5 4H11v15H5.5A1.5 1.5 0 0 1 4 17.5zM20 5.5A1.5 1.5 0 0 0 18.5 4H13v15h5.5a1.5 1.5 0 0 0 1.5-1.5z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>',
    hoja: '<path d="M5 19c0-8 5-13 14-14-1 9-6 14-14 14zM5 19l7-7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>',
    carrito: '<path d="M4 5h2l2 10h9.5l2-7H7.2" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><circle cx="9.5" cy="19" r="1.4" fill="currentColor"/><circle cx="16.5" cy="19" r="1.4" fill="currentColor"/>'
  };
  function icono(n) { return '<svg class="ffq-ico" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + (ICONOS[n] || '') + '</svg>'; }

  /* ---------- Interfaz ---------- */

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function precio(n) {
    if (n == null || isNaN(n)) return '';
    return '$' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  var movimientoReducido = function () {
    return !!(global.matchMedia && global.matchMedia('(prefers-reduced-motion: reduce)').matches);
  };
  function esperar(ms) { return new Promise(function (ok) { setTimeout(ok, movimientoReducido() ? 0 : ms); }); }

  function publicar(evento, datos) {
    try { if (global.Shopify && global.Shopify.analytics && global.Shopify.analytics.publish) global.Shopify.analytics.publish('ffq_' + evento, datos || {}); } catch (e) { /* sin analítica */ }
    try { if (typeof global.clarity === 'function') global.clarity('event', 'ffq_' + evento); } catch (e) { /* sin Clarity */ }
  }

  var CLAVE_ESTADO = 'ffq:v2';
  function guardar(estado) {
    try {
      var r = {}; Object.keys(estado.r).forEach(function (k) { if (k !== 'p7' && k !== 'p7b') r[k] = estado.r[k]; });
      sessionStorage.setItem(CLAVE_ESTADO, JSON.stringify({ r: r, ts: Date.now() }));
    } catch (e) { /* almacenamiento bloqueado */ }
  }
  function recuperar() {
    try {
      var d = JSON.parse(sessionStorage.getItem(CLAVE_ESTADO) || 'null');
      if (d && Date.now() - d.ts < 30 * 60 * 1000) return d;
    } catch (e) { /* almacenamiento bloqueado */ }
    return null;
  }
  function olvidar() { try { sessionStorage.removeItem(CLAVE_ESTADO); } catch (e) { /* nada */ } }

  function montar(raiz, cfg) {
    var T = cfg.textos, P = cfg.productos || {}, A = cfg.acciones || {};
    var C = T.chat, R = T.resultado, H = T.hongos;
    // Incrustado en el home: parte directo en la pregunta 1, sin pantalla de inicio,
    // y no mueve la página ni toma el foco hasta que la persona toca algo.
    var incrustado = !!cfg.incrustado;
    var estado = { r: {}, ultimo: null, res: null, empezo: false };
    // Incrustado: la barra de progreso solo queda fija cuando la persona ya empezó (si solo pasa de largo, no tapa nada)
    if (incrustado) raiz.setAttribute('data-ffq-incrustado', '');
    function marcarEmpezo() { raiz.setAttribute('data-ffq-empezo', ''); }
    var turno = 0;
    var observador = null;
    var nuevaPestana = '<span class="ffq-solo-sr"> ' + esc(R.nueva_pestana) + '</span>';
    // Imágenes que reemplazan a los dibujos SVG de los hongos y al avatar. Opcional: { hongos: { melena: { src, srcset, w, h } }, avatar: { src } }.
    var IMG = cfg.imagenes || {};
    function ilusDe(h, clase) {
      var i = IMG.hongos && IMG.hongos[h];
      if (!i || !i.src) return ilustracion(h, clase);
      return '<img class="' + clase + ' ffq-ilus-img" src="' + esc(i.src) + '"' + (i.srcset ? ' srcset="' + esc(i.srcset) + '" sizes="(min-width: 560px) 200px, 168px"' : '') +
        (i.w && i.h ? ' width="' + Number(i.w) + '" height="' + Number(i.h) + '"' : '') + ' alt="" decoding="async">';
    }
    var avatar = IMG.avatar && IMG.avatar.src ? '<img src="' + esc(IMG.avatar.src) + '" alt="" width="64" height="64" decoding="async">' : AVATAR;
    // Ilustración del momento del día por hongo (cabecera del resultado). Opcional: { melena: { src, srcset, w, h } }.
    var ESCENAS = cfg.escenas || {};
    var TAMANOS_ESCENA = '(min-width: 900px) 560px, (min-width: 600px) 540px, calc(100vw - 40px)';
    function escena(h) {
      var e = ESCENAS[h];
      if (!e || !e.src) return '';
      return '<figure class="ffq-escena" aria-hidden="true"><img src="' + esc(e.src) + '"' + (e.srcset ? ' srcset="' + esc(e.srcset) + '" sizes="' + TAMANOS_ESCENA + '"' : '') +
        (e.w && e.h ? ' width="' + Number(e.w) + '" height="' + Number(e.h) + '"' : '') + (e.pos ? ' style="object-position:' + esc(e.pos) + '"' : '') + ' alt="" decoding="async"></figure>';
    }
    // Se baja mientras dice "Buscando tu hongo…", para que aparezca junto con el resultado.
    function precargarEscena(h) {
      var e = ESCENAS[h];
      if (!e || !e.src || typeof Image === 'undefined') return;
      var i = new Image();
      if (e.srcset) { i.sizes = TAMANOS_ESCENA; i.srcset = e.srcset; }
      i.src = e.src;
    }

    raiz.classList.add('ffq');
    raiz.innerHTML =
      '<div class="ffq-barra" hidden>' +
        '<button type="button" class="ffq-atras" aria-label="Volver">' + icono('atras') + '</button>' +
        '<div class="ffq-progreso" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-label="Avance del test"><span></span></div>' +
        '<span class="ffq-cuenta" aria-hidden="true"></span>' +
      '</div>' +
      '<div class="ffq-cuerpo"></div>' +
      '<div class="ffq-pie" hidden><div class="ffq-pie-in"></div></div>' +
      '<div class="ffq-vivo" aria-live="polite" role="status"></div>' +
      '<div class="ffq-aviso" role="status" aria-live="polite" hidden></div>';

    var barra = raiz.querySelector('.ffq-barra'), cuerpo = raiz.querySelector('.ffq-cuerpo');
    var pie = raiz.querySelector('.ffq-pie'), pieIn = raiz.querySelector('.ffq-pie-in');
    var vivo = raiz.querySelector('.ffq-vivo'), aviso = raiz.querySelector('.ffq-aviso');
    var progreso = raiz.querySelector('.ffq-progreso'), cuenta = raiz.querySelector('.ffq-cuenta');
    var botonAtras = barra.querySelector('.ffq-atras');

    botonAtras.addEventListener('click', atras);
    raiz.addEventListener('click', function (e) {
      var b = e.target.closest('[data-accion]');
      if (b && raiz.contains(b) && estado.res) accion(b.dataset.accion, b, estado.res, e);
    });

    function anunciar(t) { vivo.textContent = ''; setTimeout(function () { vivo.textContent = t; }, 40); }
    function avisar(t) {
      aviso.textContent = t; aviso.hidden = false;
      requestAnimationFrame(function () { aviso.classList.add('is-on'); });
      clearTimeout(avisar.t);
      avisar.t = setTimeout(function () { aviso.classList.remove('is-on'); setTimeout(function () { aviso.hidden = true; }, 260); }, 2600);
    }
    function apagarObservador() { if (observador) { observador.disconnect(); observador = null; } pie.classList.remove('is-fuera', 'is-resultado'); pie.style.marginTop = ''; }
    // Alto de lo que el tema deja fijo arriba (encabezado pegajoso), para no quedar tapado.
    function altoFijo() {
      var h = 0;
      try { h = A.altoSuperior ? A.altoSuperior() : 0; } catch (e) { h = 0; }
      raiz.style.setProperty('--ffq-top', (h || 0) + 'px');
      return h || 0;
    }
    // Medir el encabezado al montar y al cambiar el tamaño, no solo al tocar el test (02-11: la barra tapaba el encabezado)
    altoFijo();
    global.addEventListener('resize', function () { clearTimeout(altoFijo.t); altoFijo.t = setTimeout(altoFijo, 150); });
    // El encabezado cambia de alto al bajar (la barra de anuncios deja de verse): con la barra fija, volver a medir al desplazarse
    var midiendo = false;
    global.addEventListener('scroll', function () {
      if (midiendo || (incrustado && !estado.empezo)) return;
      midiendo = true;
      requestAnimationFrame(function () { altoFijo(); midiendo = false; });
    }, { passive: true });
    function irArriba() {
      if (incrustado && !estado.empezo) return;
      var y = raiz.getBoundingClientRect().top + global.pageYOffset - 8 - altoFijo();
      if (global.pageYOffset > y) global.scrollTo({ top: Math.max(0, y), behavior: 'auto' });
    }

    function pasoActual() {
      var ps = pasos(estado.r);
      for (var i = 0; i < ps.length; i++) if (estado.r[ps[i]] == null) return ps[i];
      return 'resultado';
    }

    function actualizarBarra(paso) {
      var ps = pasos(estado.r), i = ps.indexOf(paso), total = ps.length;
      var pct = paso === 'resultado' ? 100 : Math.round(100 * Math.sqrt((i + 0.6) / (total + 0.6)));
      progreso.firstElementChild.style.width = pct + '%';
      progreso.setAttribute('aria-valuenow', String(pct));
      progreso.setAttribute('aria-valuetext', paso === 'resultado' ? 'Completado' : 'Pregunta ' + (i + 1) + ' de ' + total);
      cuenta.textContent = paso === 'resultado' ? '' : (i + 1) + ' de ' + total;
      botonAtras.setAttribute('aria-label', paso === 'p1' ? 'Volver al inicio' : 'Volver a la pregunta anterior');
      botonAtras.style.visibility = incrustado && paso === 'p1' ? 'hidden' : '';
      barra.hidden = paso === 'resultado';
    }

    function textoPregunta(paso) {
      var q = T.preguntas[paso];
      if (paso === 'p5' && estado.r.p1 === 'cuidarse') return q.texto_cuidarse;
      return q.texto;
    }
    function opcionesDe(paso) {
      var q = T.preguntas[paso], r = estado.r;
      if (paso === 'p2') return (q.grupos[r.p1] || []).map(function (id) { return buscar(T, 'p2', id); }).filter(Boolean);
      if (paso === 'p3') return q.opciones.filter(function (o) { return o.rama !== r.p1; });
      if (paso === 'p5' && r.p1 === 'cuidarse') return q.opciones_cuidarse;
      return q.opciones;
    }
    // Acuse corto de la respuesta anterior, que aparece arriba de la pregunta siguiente.
    function acuseAntes(paso) {
      var ps = pasos(estado.r), i = ps.indexOf(paso);
      if (i <= 0) return '';
      var prev = ps[i - 1];
      return prev === 'p1' ? (T.acuses[estado.r.p1] || '') : (T.acuses[prev] || '');
    }

    /* ---- Inicio ---- */
    function vistaInicio() {
      var I = T.inicio;
      turno++; estado.res = null; apagarObservador();
      barra.hidden = true; pie.hidden = true; raiz.dataset.paso = 'inicio';
      cuerpo.innerHTML =
        '<section class="ffq-inicio">' +
          // Página sola del test (02-11, Mau: «se ve vacía»): ilustración botánica de los cuatro hongos arriba del título
          (!incrustado && IMG.bodegon && IMG.bodegon.src ? '<figure class="ffq-inicio-bodegon" aria-hidden="true"><img src="' + esc(IMG.bodegon.src) + '"' +
            (IMG.bodegon.srcset ? ' srcset="' + esc(IMG.bodegon.srcset) + '" sizes="(min-width: 600px) 560px, calc(100vw - 40px)"' : '') +
            (IMG.bodegon.w && IMG.bodegon.h ? ' width="' + Number(IMG.bodegon.w) + '" height="' + Number(IMG.bodegon.h) + '"' : '') + ' alt="" decoding="async" fetchpriority="high"></figure>' : '') +
          '<div class="ffq-inicio-texto">' +
            '<p class="ffq-eyebrow">' + esc(I.eyebrow) + '</p>' +
            '<h1 class="ffq-h1">' + esc(I.titulo) + '</h1>' +
            '<p class="ffq-bajada">' + esc(I.bajada) + '</p>' +
          '</div>' +
          '<button type="button" class="ffq-btn ffq-btn-primario ffq-empezar">' + esc(I.boton) + icono('flecha') + '</button>' +
          '<ul class="ffq-puntos">' + I.puntos.concat(I.confianza.slice(0, 1)).map(function (p) { return '<li>' + icono('check') + esc(p) + '</li>'; }).join('') + '</ul>' +
        '</section>';
      cuerpo.querySelector('.ffq-empezar').addEventListener('click', function () {
        publicar('inicio');
        estado.empezo = true; marcarEmpezo();
        dibujarPaso(true);
      });
    }

    /* ---- Una pregunta por pantalla ---- */
    function dibujarPaso(animar) {
      var mio = ++turno;
      estado.res = null; apagarObservador();
      var actual = pasoActual();
      if (actual === 'resultado') { guardar(estado); return transicionResultado(animar); }
      actualizarBarra(actual);
      raiz.dataset.paso = actual;
      pie.hidden = true;

      var q = T.preguntas[actual];
      var multiple = q.tipo === 'varias';
      var ops = opcionesDe(actual);
      var u = estado.ultimo && estado.ultimo.paso === actual ? estado.ultimo.valor : null;
      var previas = u == null ? [] : (Array.isArray(u) ? u : [u]);
      var a = acuseAntes(actual);

      cuerpo.innerHTML =
        '<div class="ffq-paso' + (animar ? ' is-nuevo' : '') + '">' +
          '<div class="ffq-msg ffq-bot is-pregunta"><span class="ffq-av">' + avatar + '</span><div class="ffq-burbuja">' +
            (a ? '<p class="ffq-acuse">' + esc(a) + '</p>' : '') +
            '<h2 class="ffq-pregunta" tabindex="-1" id="ffq-q-' + actual + '">' + esc(textoPregunta(actual)) + '</h2>' +
            (q.ayuda ? '<p class="ffq-ayuda">' + (actual === 'p7' || actual === 'p7b' ? icono('candado') : '') + esc(q.ayuda) + '</p>' : '') +
          '</div></div>' +
          '<div class="ffq-opciones' + (multiple ? ' is-multi' : '') + '" role="group" aria-labelledby="ffq-q-' + actual + '"' + (actual === 'p7' || actual === 'p7b' ? ' data-clarity-mask="true"' : '') + '>' +
            ops.map(function (o, i) {
              var on = previas.indexOf(o.id) !== -1;
              return '<button type="button" class="ffq-op' + (multiple ? ' is-multi' : '') + (o.excluyente ? ' is-excluyente' : '') + (on ? ' is-on' : '') + '"' +
                ' data-id="' + esc(o.id) + '"' + (multiple ? ' aria-pressed="' + on + '"' : '') + ' style="--i:' + i + '">' +
                (multiple ? '<span class="ffq-op-marca" aria-hidden="true">' + icono('check') + '</span>' : '') +
                '<span class="ffq-op-texto">' + esc(o.texto) + '</span>' +
                (multiple ? '' : '<span class="ffq-op-flecha" aria-hidden="true">' + icono('flecha') + '</span>') +
              '</button>';
            }).join('') +
          '</div>' +
        '</div>';

      configurarOpciones(actual, multiple);
      pie.hidden = !multiple;
      irArriba();
      var h = cuerpo.querySelector('.ffq-pregunta');
      if (estado.empezo) { try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); } }
      var ps = pasos(estado.r);
      anunciar('Pregunta ' + (ps.indexOf(actual) + 1) + ' de ' + ps.length);
      publicar('paso', { paso: actual, n: ps.indexOf(actual) + 1, total: ps.length });
      return mio;
    }

    function configurarOpciones(paso, multiple) {
      var botones = Array.prototype.slice.call(cuerpo.querySelectorAll('.ffq-op'));
      var seleccion = function () { return botones.filter(function (b) { return b.classList.contains('is-on'); }).map(function (b) { return b.dataset.id; }); };

      if (!multiple) {
        botones.forEach(function (b) {
          b.addEventListener('click', function () {
            if (raiz.dataset.bloqueo) return;
            raiz.dataset.bloqueo = '1';
            botones.forEach(function (x) { x.classList.toggle('is-on', x === b); x.classList.toggle('is-atenuada', x !== b); });
            esperar(220).then(function () { delete raiz.dataset.bloqueo; responder(paso, b.dataset.id); });
          });
        });
        return;
      }

      // Varias respuestas: sin nada marcado, el botón del pie ofrece la opción "ninguna".
      var excl = botones.filter(function (b) { return b.classList.contains('is-excluyente'); })[0];
      pieIn.innerHTML = '<button type="button" class="ffq-btn ffq-btn-primario ffq-continuar"></button>';
      var continuar = pieIn.querySelector('.ffq-continuar');
      var refrescar = function () {
        var vacio = seleccion().length === 0;
        continuar.disabled = vacio && !excl;
        continuar.classList.toggle('is-suave', vacio && !!excl);
        continuar.innerHTML = (vacio ? (excl ? esc(excl.querySelector('.ffq-op-texto').textContent) : esc(C.marca_una)) : esc(C.continuar)) + icono('flecha');
      };
      botones.forEach(function (b) {
        b.addEventListener('click', function () {
          var on = !b.classList.contains('is-on');
          var esExcl = b.classList.contains('is-excluyente');
          botones.forEach(function (x) {
            if (on && x !== b && (esExcl || x.classList.contains('is-excluyente'))) { x.classList.remove('is-on'); x.setAttribute('aria-pressed', 'false'); }
          });
          b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', String(on));
          refrescar();
        });
      });
      continuar.addEventListener('click', function () {
        var v = seleccion();
        if (!v.length && excl) v = [excl.dataset.id];
        if (v.length) responder(paso, v);
      });
      refrescar();
    }

    function responder(paso, valor) {
      if (incrustado && !estado.empezo) { estado.empezo = true; marcarEmpezo(); publicar('inicio', { origen: 'home', p1: valor }); }
      estado.r[paso] = valor;
      estado.ultimo = null;
      if (paso === 'p1') ['p2', 'p3', 'p5'].forEach(function (k) { delete estado.r[k]; });
      if (paso === 'p7') delete estado.r.p7b;
      if (paso !== 'p7' && paso !== 'p7b') publicar('respuesta', { paso: paso, valor: Array.isArray(valor) ? valor.join(',') : valor });
      guardar(estado);
      dibujarPaso(true);
    }

    function atras() {
      var actual = pasoActual();
      var ps = pasos(estado.r);
      var i = actual === 'resultado' ? ps.length : ps.indexOf(actual);
      if (i <= 0) { if (incrustado) return; publicar('atras', { paso: 'inicio' }); return vistaInicio(); }
      var anterior = ps[i - 1];
      estado.ultimo = { paso: anterior, valor: estado.r[anterior] };
      delete estado.r[anterior];
      publicar('atras', { paso: anterior });
      dibujarPaso(false);
    }

    /* ---- Resultado ---- */
    function transicionResultado(animar) {
      if (!animar || movimientoReducido()) return vistaResultado();
      var mio = ++turno;
      barra.hidden = true; pie.hidden = true;
      cuerpo.innerHTML = '<div class="ffq-buscando" role="status">' +
        '<div class="ffq-mini-hongos" aria-hidden="true">' +
          HONGOS.map(function (h) { return '<span style="--h-suave:' + H[h].colorSuave + '">' + ilusDe(h, 'ffq-ilus') + '</span>'; }).join('') +
        '</div><p>' + esc(C.analizando) + '</p></div>';
      irArriba();
      // En la tienda, mientras se "busca", se leen los precios reales de Kaching (máximo 2,5 s).
      var claves = [];
      var prev = puntuar(estado.r, P);
      if (prev.modo !== 'stop') precargarEscena(prev.oferta.hongos[0]);
      if (A.actualizarPrecios) {
        claves = [prev.oferta.clave].concat(prev.oferta.hongos, prev.alternativas.map(function (a) { return a.clave; })).filter(Boolean);
      }
      var precios = A.actualizarPrecios ? Promise.race([A.actualizarPrecios(P, claves), new Promise(function (ok) { setTimeout(ok, 2500); })]) : Promise.resolve();
      Promise.all([esperar(1300), precios]).then(function () { if (mio === turno) vistaResultado(); });
    }

    function vistaResultado() {
      turno++;
      var res = puntuar(estado.r, P);
      estado.res = res;
      var principal = res.oferta.hongos[0];
      var colores = res.modo === 'stop' ? { color: '#9A8F82', colorTexto: '#5C534B', colorSuave: '#F4EFE6' } : H[principal];
      raiz.dataset.paso = 'resultado';
      actualizarBarra('resultado');
      raiz.style.setProperty('--h', colores.color);
      raiz.style.setProperty('--h-texto', colores.colorTexto);
      raiz.style.setProperty('--h-suave', colores.colorSuave);
      publicar('resultado', { match: principal, oferta: res.oferta.tipo, modo: res.modo });

      var texto = resumen(estado.r, T).map(function (s) { return s.eco ? '<mark>' + esc(s.t) + '</mark>' : esc(s.t); }).join('');

      var html = '<article class="ffq-res ffq-res-' + res.modo + '">' +
        '<header class="ffq-res-cabeza">' +
          (res.modo === 'stop' ? '' : escena(principal)) +
          '<p class="ffq-eyebrow">' + esc(R.eyebrow) + '</p>' +
          '<p class="ffq-historia" tabindex="-1">' + texto + '</p>' +
        '</header>';

      if (res.modo === 'stop') {
        html += '<section class="ffq-alto">' + icono('escudo') +
          '<h2 class="ffq-h2">' + esc(T.seguridad.titulo_stop) + '</h2>' +
          res.avisos.filter(function (a) { return T.seguridad[a]; }).map(function (a) { return '<p>' + esc(T.seguridad[a]) + '</p>'; }).join('') +
          (A.whatsapp ? '<a class="ffq-btn ffq-btn-secundario" href="' + esc(A.whatsapp) + '" target="_blank" rel="noopener">' + esc(T.seguridad.boton_stop) + nuevaPestana + '</a>' : '') +
        '</section>';
      } else {
        html += tarjeta(res);
        html += '<div class="ffq-mas">' + plegableComo(res) + plegableHabito(res) + '</div>';
        if (res.modo === 'normal') html += alternativa(res);
      }

      html += '<footer class="ffq-res-pie">' +
        '<div class="ffq-res-acciones">' +
          '<button type="button" class="ffq-btn ffq-btn-terciario" data-accion="rehacer">' + icono('rehacer') + esc(R.rehacer) + '</button>' +
          '<button type="button" class="ffq-btn ffq-btn-terciario" data-accion="compartir">' + icono('compartir') + esc(R.compartir) + '</button>' +
        '</div>' +
        '<p class="ffq-disclaimer">' + esc(R.disclaimer) + '</p>' +
      '</footer></article>';

      cuerpo.innerHTML = html;

      // Barra fija de compra: solo cuando el botón de la tarjeta no está a la vista.
      apagarObservador();
      if (res.modo === 'normal' && infoOferta(res.oferta).url) {
        var o = infoOferta(res.oferta);
        pieIn.innerHTML = '<div class="ffq-pie-compra"><div><strong>' + esc(o.nombre) + '</strong><span>' + esc(o.precioTxt) + '</span></div>' +
          '<a class="ffq-btn ffq-btn-primario" href="' + esc(o.url || '#') + '" data-accion="producto">' + esc(res.oferta.tipo === 'dos' ? 'Ver ' + H[res.oferta.hongos[0]].nombre : R.ver_producto) + '</a></div>';
        pie.hidden = false;
        var cta = cuerpo.querySelector('.ffq-reco [data-accion="producto"]');
        if (cta && 'IntersectionObserver' in global) {
          // La barra aparece solo entre el botón de la tarjeta y el final del resultado: no reserva espacio
          // (margen negativo) y se esconde en los dos extremos, donde ya hay un botón o el pie del resultado.
          var fin = cuerpo.querySelector('.ffq-res-pie'), vis = {};
          pie.classList.add('is-fuera', 'is-resultado');
          global.requestAnimationFrame(function () { pie.style.marginTop = -pie.offsetHeight + 'px'; });
          observador = new IntersectionObserver(function (es) {
            es.forEach(function (e) {
              if (e.target === cta) { vis.cta = e.isIntersecting; vis.ctaAbajo = !e.isIntersecting && e.boundingClientRect.top > global.innerHeight; }
              else vis.fin = e.isIntersecting;
            });
            pie.classList.toggle('is-fuera', !!(vis.cta || vis.ctaAbajo || vis.fin));
          });
          observador.observe(cta);
          if (fin) observador.observe(fin);
        }
      } else {
        pie.hidden = true;
      }

      irArriba();
      var foco = cuerpo.querySelector('.ffq-historia');
      try { foco.focus({ preventScroll: true }); } catch (e) { /* nada */ }
      anunciar('Tu resultado está listo.');
    }

    function infoOferta(oferta) {
      if (oferta.tipo === 'pack4') {
        var p4 = P.pack4 || {};
        return { nombre: 'Pack de 4 extractos', precio: p4.precio, precioTxt: precio(p4.precio), url: p4.url, items: [p4.variante], detalle: '4 frascos, uno de cada hongo · se toman juntos y rinden 1 mes', lista: p4.lista };
      }
      if (oferta.tipo === 'duo') {
        var d = P[oferta.clave] || {};
        var sueltos = oferta.hongos.reduce(function (s, h) { return s + ((P[h] || {}).precio || 0); }, 0);
        return { nombre: H[oferta.hongos[0]].nombre + ' + ' + H[oferta.hongos[1]].nombre, precio: d.precio, precioTxt: precio(d.precio), sueltos: sueltos, url: d.url, items: [d.variante], detalle: '2 frascos · se toman juntos y rinden 1 mes', lista: d.lista };
      }
      if (oferta.tipo === 'dos') {
        var total = oferta.hongos.reduce(function (s, h) { return s + ((P[h] || {}).precio || 0); }, 0);
        return { nombre: H[oferta.hongos[0]].nombre + ' + ' + H[oferta.hongos[1]].nombre, precio: total, precioTxt: precio(total), url: (P[oferta.hongos[0]] || {}).url, items: oferta.hongos.map(function (h) { return (P[h] || {}).variante; }), detalle: '2 frascos · se toman juntos y rinden 1 mes', lista: oferta.hongos.reduce(function (s, h) { return s + ((P[h] || {}).lista || (P[h] || {}).precio || 0); }, 0) };
      }
      var s = P[oferta.hongos[0]] || {};
      return { nombre: H[oferta.hongos[0]].nombre, precio: s.precio, precioTxt: precio(s.precio), url: s.url, items: [s.variante], detalle: '1 frasco · rinde 1 mes', lista: s.lista };
    }

    function tarjeta(res) {
      var o = infoOferta(res.oferta);
      var hs = res.oferta.tipo === 'pack4' ? HONGOS : res.oferta.hongos;
      var consulta = res.modo === 'consulta';
      var info = P[res.oferta.clave] || P[res.oferta.hongos[0]] || {};
      var ahorro = o.sueltos && o.precio && o.sueltos > o.precio ? o.sueltos - o.precio : 0;
      return '<section class="ffq-reco' + (hs.length > 1 ? ' is-varios' : '') + '" aria-labelledby="ffq-reco-nombre">' +
        '<div class="ffq-reco-arte" aria-hidden="true">' +
          hs.map(function (h) { return '<div class="ffq-reco-ilus" style="--h-suave:' + H[h].colorSuave + '">' + ilusDe(h, 'ffq-ilus') + '</div>'; }).join('') +
        '</div>' +
        '<div class="ffq-reco-info">' +
          '<p class="ffq-eyebrow">' + esc(R.para_ti) + '</p>' +
          '<h1 class="ffq-reco-nombre" id="ffq-reco-nombre">' + esc(o.nombre) + '</h1>' +
          (res.sinNecesidad ? '<p class="ffq-reco-texto">' + esc(R.nada_urgente) + '</p>' : '') +
          '<ul class="ffq-razones">' + (res.oferta.tipo === 'pack4' ? [] : hs).map(function (h) {
            return '<li><span class="ffq-chip" style="--c:' + H[h].colorTexto + ';--s:' + H[h].colorSuave + '">' + esc(H[h].foco) + '</span>' + esc(H[h].corto) + '</li>';
          }).join('') + '</ul>' +
          (info.resenas ? '<p class="ffq-rating">' + icono('estrella') + '<span>' + esc(info.rating || '5,0') + ' · ' + esc(info.resenas) + ' reseñas</span></p>' : '') +
          (consulta ? '<div class="ffq-consulta" role="note">' + icono('escudo') + '<div><strong>' + esc(T.seguridad.titulo_consulta) + '</strong>' +
            res.avisos.filter(function (a) { return T.seguridad[a]; }).map(function (a) { return '<p>' + esc(T.seguridad[a]) + '</p>'; }).join('') + '</div></div>' : '') +
          '<div class="ffq-precio">' +
            (o.precioTxt ? '<strong>' + esc(o.precioTxt) + '</strong>' : '') +
            (o.lista && o.precio && o.lista > o.precio ? '<s class="ffq-antes">' + esc(precio(o.lista)) + '</s>' : '') +
            (ahorro ? '<span class="ffq-ahorro">' + esc(R.duo_ahorro.replace('{ahorro}', precio(ahorro))) + '</span>' : '') +
            '<span class="ffq-detalle">' + esc(o.detalle) + '</span>' +
          '</div>' +
          '<div class="ffq-reco-botones">' +
            (consulta
              ? (o.url ? '<a class="ffq-btn ffq-btn-secundario" href="' + esc(o.url) + '">' + esc(T.seguridad.boton_consulta) + '</a>' : '')
              : (o.url ? '<a class="ffq-btn ffq-btn-primario" href="' + esc(o.url) + '" data-accion="producto">' + esc(res.oferta.tipo === 'dos' ? 'Ver ' + H[res.oferta.hongos[0]].nombre : R.ver_producto) + icono('flecha') + '</a>' : '') +
                // Sin dúo armado para este par: un botón por hongo, para no dejar a medias la recomendación.
                (res.oferta.tipo === 'dos' && (P[res.oferta.hongos[1]] || {}).url ? '<a class="ffq-btn ffq-btn-secundario" href="' + esc(P[res.oferta.hongos[1]].url) + '" data-accion="producto">' + esc('Ver ' + H[res.oferta.hongos[1]].nombre) + icono('flecha') + '</a>' : '')) +
          '</div>' +
          (!consulta && R.confianza ? '<ul class="ffq-sellos">' + R.confianza.map(function (c) { return '<li>' + icono('check') + esc(c) + '</li>'; }).join('') + '</ul>' : '') +
        '</div>' +
      '</section>';
    }

    function plegable(titulo, contenido, ico) {
      return '<details class="ffq-plegable"><summary>' + icono(ico) + '<span>' + esc(titulo) + '</span></summary><div class="ffq-plegable-in">' + contenido + '</div></details>';
    }

    // Sin uso desde el 12-10 (Mau sacó «Qué dicen los estudios» del resultado). Se deja por si vuelve.
    function plegableEstudios(res) {
      var hs = res.oferta.tipo === 'pack4' ? HONGOS : res.oferta.hongos;
      return plegable(R.estudios, hs.map(function (h) {
        var x = H[h];
        return '<div class="ffq-hongo" style="--c:' + x.colorTexto + ';--s:' + x.colorSuave + '">' +
          (hs.length > 1 ? '<h3 class="ffq-h3">' + esc(x.nombre) + '</h3>' : '') +
          '<p><b>' + esc(R.estudiado) + ':</b> ' + esc(x.estudio) + '</p>' +
          '<p><b>' + esc(R.honesto) + ':</b> ' + esc(x.honesto) + '</p>' +
          '<a class="ffq-fuente" href="' + esc(x.url) + '" target="_blank" rel="noopener">' + esc(x.fuente) + icono('externo') + nuevaPestana + '</a>' +
        '</div>';
      }).join(''), 'libro');
    }

    function plegableComo(res) {
      var hs = res.oferta.tipo === 'pack4' ? [] : res.oferta.hongos;
      var momento = hs.map(function (h) { return (hs.length > 1 ? H[h].nombre + ': ' : '') + H[h].momento; }).join(' ');
      // Sin el aviso ni el enlace de la Bitácora desde el 16-10 (pedido de Mau).
      return plegable(R.como, '<p>' + esc(R.como_texto) + (momento ? ' ' + esc(momento) : '') + '</p>', 'gota');
    }

    // Sin uso desde el 12-10 (Mau sacó el acordeón del resultado; quedan el aviso del pie y las fichas). Se deja por si vuelve.
    function plegablePrecauciones(res) {
      var hs = res.oferta.tipo === 'pack4' ? HONGOS : res.oferta.hongos;
      return plegable(R.precauciones, '<p>' + esc(R.precauciones_comun) + '</p>' +
        hs.filter(function (h) { return H[h].precauciones; }).map(function (h) {
          return '<p>' + (hs.length > 1 ? '<b>' + esc(H[h].nombre) + ':</b> ' : '') + esc(H[h].precauciones) + '</p>';
        }).join(''), 'escudo');
    }

    function plegableHabito(res) {
      var x = T.habitos[res.habitos[0]];
      if (!x) return '';
      return plegable(R.habito, '<h3 class="ffq-h3">' + esc(x.titulo) + '</h3><p>' + esc(x.texto) + '</p>' +
        '<a class="ffq-fuente" href="' + esc(x.url) + '" target="_blank" rel="noopener">' + esc(x.fuente) + icono('externo') + nuevaPestana + '</a>', 'hoja');
    }

    function alternativa(res) {
      var a = res.alternativas[0];
      if (!a) return '';
      var p = P[a.clave] || {}, nombre, hs;
      if (a.tipo === 'pack4') { nombre = 'Pack de 4 extractos'; hs = ['melena', 'reishi']; }
      else if (a.tipo === 'funcoffee') { nombre = 'FunCoffee, café con Melena y Cordyceps'; hs = ['melena', 'cordyceps']; }
      else { nombre = a.hongos.map(function (h) { return H[h].nombre; }).join(' + '); hs = a.hongos; }
      return '<section class="ffq-bloque-alt"><p class="ffq-eyebrow">' + esc(R.alternativa) + '</p>' +
        '<a class="ffq-alt" href="' + esc(p.url || '#') + '">' +
          '<span class="ffq-alt-arte" aria-hidden="true">' + hs.slice(0, 2).map(function (h) { return '<span style="--h-suave:' + H[h].colorSuave + '">' + ilusDe(h, 'ffq-ilus') + '</span>'; }).join('') + '</span>' +
          '<span class="ffq-alt-info"><strong>' + esc(nombre) + '</strong><em>' + esc(precio(p.precio)) + '</em></span>' +
          '<span class="ffq-alt-flecha" aria-hidden="true">' + icono('flecha') + '</span></a></section>';
    }

    function accion(nombre, boton, res, evento) {
      if (nombre === 'rehacer') {
        estado.r = {}; estado.ultimo = null; estado.res = null; olvidar(); publicar('rehacer');
        apagarObservador();
        raiz.style.removeProperty('--h'); raiz.style.removeProperty('--h-texto'); raiz.style.removeProperty('--h-suave');
        pie.hidden = true;
        dibujarPaso(true);
        return;
      }
      if (nombre === 'compartir') {
        var url = A.urlCompartir || global.location.href.split('#')[0];
        publicar('compartir');
        if (navigator.share && !A.sinShare) { navigator.share({ title: T.inicio.titulo, url: url }).catch(function () {}); return; }
        if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () { avisar(R.compartido); }, function () { avisar(url); });
        else avisar(url);
        return;
      }
      if (nombre === 'bitacora') { publicar('bitacora'); return; }
      if (nombre === 'producto') {
        // Marca el carrito como venido del quiz antes de ir a la ficha (sin esperar más de 700 ms).
        var etiquetaP = ['v3', res.oferta.hongos.join('+'), res.oferta.tipo].join('|');
        publicar('ver_producto', { match: res.oferta.hongos[0], oferta: res.oferta.tipo });
        if (A.marcar && evento) {
          evento.preventDefault();
          var destino = boton.getAttribute('href');
          Promise.race([A.marcar(etiquetaP), esperar(700)]).then(function () { global.location.href = destino; });
        }
        return;
      }
      if (nombre === 'carrito') {
        if (evento) evento.preventDefault();
        if (A.verCarrito) A.verCarrito(); else global.location.href = A.urlCarrito || '/cart';
        return;
      }
      if (nombre === 'agregar') {
        var o = infoOferta(res.oferta);
        var items = o.items.filter(Boolean);
        if (!items.length || !A.agregar) return;
        var botones = raiz.querySelectorAll('[data-accion="agregar"]');
        botones.forEach(function (b) { b.disabled = true; b.classList.add('is-cargando'); });
        var etiqueta = ['v2', res.oferta.hongos.join('+'), res.oferta.tipo].join('|');
        Promise.resolve(A.agregar(items, etiqueta)).then(function () {
          publicar('agregar', { match: res.oferta.hongos[0], oferta: res.oferta.tipo });
          avisar(R.agregado);
          botones.forEach(function (b) {
            b.dataset.accion = 'carrito';
            b.classList.add('is-listo');
            b.innerHTML = icono('check') + esc(b.closest('.ffq-pie') ? R.ver_carrito : R.en_carrito);
          });
        }, function (err) {
          avisar((err && err.message) || R.error_agregar);
        }).then(function () {
          botones.forEach(function (b) { b.disabled = false; b.classList.remove('is-cargando'); });
        });
      }
    }

    // Empezar con una respuesta ya elegida (tarjetas del home): baja al quiz y sigue en la pregunta 2.
    // desde: de dónde vino (ej. la tarjeta tocada), solo para analítica; no marca ninguna respuesta.
    function empezarCon(p1, desde) {
      var valida = p1 && T.preguntas.p1.opciones.some(function (o) { return o.id === p1; });
      estado.r = valida ? { p1: p1 } : {}; estado.ultimo = null; estado.empezo = true; marcarEmpezo(); estado.res = null;
      raiz.style.removeProperty('--h'); raiz.style.removeProperty('--h-texto'); raiz.style.removeProperty('--h-suave');
      publicar('inicio', { origen: desde ? 'tarjeta' : 'enlace', tarjeta: desde || null, p1: valida ? p1 : null });
      dibujarPaso(true);
      // Las tarjetas y el hero están más arriba: bajar hasta el quiz (irArriba solo sube).
      var y = raiz.getBoundingClientRect().top + global.pageYOffset - 8 - altoFijo();
      global.scrollTo({ top: Math.max(0, y), behavior: movimientoReducido() ? 'auto' : 'smooth' });
    }

    if (incrustado) {
      dibujarPaso(false);
      publicar('vista', { origen: 'home' });
      return { estado: estado, empezarCon: empezarCon };
    }

    // Arranque: si viene del home con la primera respuesta (?p1=energia), parte en la pregunta 2.
    // Si no, retoma un test a medio camino; si no hay nada, muestra el inicio.
    var desdePortada = null;
    try { desdePortada = new URLSearchParams(global.location.search).get('p1'); } catch (e) { /* nada */ }
    var p1Valida = desdePortada && T.preguntas.p1.opciones.some(function (o) { return o.id === desdePortada; });
    var previo = recuperar();
    if (p1Valida) {
      estado.r = { p1: desdePortada }; estado.empezo = true; marcarEmpezo(); guardar(estado);
      try { global.history.replaceState(null, '', global.location.pathname + global.location.search.replace(/([?&])p1=[^&]*&?/, '$1').replace(/[?&]$/, '')); } catch (e) { /* nada */ }
      publicar('inicio', { origen: 'portada', p1: desdePortada });
      dibujarPaso(true);
    } else if (previo && previo.r && previo.r.p1) { estado.r = previo.r; dibujarPaso(false); }
    else vistaInicio();
    publicar('vista');

    return { estado: estado, empezarCon: empezarCon, reiniciar: function () { estado.r = {}; olvidar(); vistaInicio(); } };
  }

  var API = { puntuar: puntuar, resumen: resumen, pasos: pasos, montar: montar, ilustracion: ilustracion, PESOS_SENAL: PESOS_SENAL, DUOS: DUOS };
  if (typeof module !== 'undefined' && module.exports) module.exports = API;
  else global.FFQuiz = API;
})(typeof window !== 'undefined' ? window : globalThis);
